import React from 'react';
import {
  Box,
  FormControl,
  FormHelperText,
  Input,
  Typography,
} from '@heycater/design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import QuestionErrors from 'qualification/components/QuestionErrors';
import { useQualification } from 'qualification/context';
import { questions } from 'qualification/schema/questions';
import useLocalizedFieldName from 'shared/hooks/useLocalizedFieldName';

const totalBudgetQuestion = questions.totalBudget;

function PriceField() {
  const { state, actions, answerOf, errorsOf } = useQualification();

  const { t } = useTranslation('qualification');

  const { localizedAttributeName } = useLocalizedFieldName();

  if (!('qualification' in state)) {
    return null;
  }

  const totalBudget = state.qualification.answers.min_order_number;

  const content = totalBudgetQuestion.content ?? {};
  const localizedAssistiveText =
    // @ts-expect-error TODO: type this function
    content[localizedAttributeName('assistiveText')];

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = async (
    event
  ) => {
    if (!totalBudget) {
      return;
    }
    const price = Number(event.target.value);

    if (isNaN(price)) {
      return;
    }

    if (price < 1) {
      return;
    }

    actions.answerQuestion(totalBudgetQuestion.id, price);
  };
  const answer = answerOf(totalBudgetQuestion.id);
  const errors = errorsOf(totalBudgetQuestion.id);

  return (
    <Wrapper
      display="flex"
      justifyContent="center"
      alignItems={{ xs: 'center', sm: 'top' }}
      mt={[2, 4]}
      mb={2}
      flexWrap="wrap"
      flexDirection={{ xs: 'column', sm: 'row' }}
    >
      <Box alignSelf={{ sm: 'start' }}>
        <Typography variant="body2" mt={2} fontWeight={600}>
          {t('total')}
        </Typography>
      </Box>
      <StyledPriceField>
        <FormControl>
          <InputWithAdornment>
            <Input
              type="number"
              name={totalBudgetQuestion.id}
              id={totalBudgetQuestion.id}
              // @ts-expect-error TODO: type this function
              placeholder={content[localizedAttributeName('placeholder')] || ''}
              onChange={handleChange}
              value={answer || ''}
            />
            <Adornment>
              <Typography>€</Typography>
            </Adornment>
          </InputWithAdornment>
          {localizedAssistiveText && (
            <StyledFormHelperText>
              {localizedAssistiveText}
            </StyledFormHelperText>
          )}
        </FormControl>
        <QuestionErrors errors={errors} />
      </StyledPriceField>
    </Wrapper>
  );
}

const Wrapper = styled(Box)`
  column-gap: ${({ theme }) => theme.spacing(7)}px;
  row-gap: ${({ theme }) => theme.spacing(1)}px;
`;

const StyledFormHelperText = styled(FormHelperText)`
  font-size: 10px;
  text-align: right;
  color: ${(props) => props.theme.palette.text.secondary};
`;

const StyledPriceField = styled.div`
  width: 243px;
`;

const InputWithAdornment = styled.div`
  position: relative;
`;

const Adornment = styled.div`
  position: absolute;
  right: ${(props) => props.theme.spacing(2)}px;
  top: 50%;
  transform: translateY(-50%);
`;

export default PriceField;
